import { admins } from 'types';
import React from 'react';
import {
    TMaterialTableColumnsRenderFC,
    TMaterialTableColumns,
} from 'components/table/index.types';
import Button from 'components/control/button/button';
import {
    EButtonSize,
    EButtonType,
} from 'components/control/button/button.types';

/** TODO: Pass only handlers */
const adminListColumns = ({
    onUnblock,
    ControlButtonsComponent,
}: {
    onUnblock: (args0: admins.TAdmins) => void;
    ControlButtonsComponent: TMaterialTableColumnsRenderFC<admins.TAdmins>;
}): TMaterialTableColumns<admins.TAdmins> => [
    {
        key: 'id',
        title: 'ID',
    },
    {
        key: 'email',
        title: 'Email',
    },
    {
        key: 'firstName',
        title: 'First name',
    },
    {
        key: 'lastName',
        title: 'Last name',
    },
    {
        key: 'role',
        title: 'Admin Role',
    },
    {
        title: 'Permission Role',
        render: (props) => {
            return <>{props.rowData.adminPermissionRole?.roleName || '-'}</>;
        },
    },
    {
        title: ' ',
        width: '50',
        render: (props) => {
            if (
                props.rowData.role === 'superadmin' ||
                !props.rowData.loginBlockedAt
            )
                return null;

            return (
                <Button
                    size={EButtonSize.Small}
                    styleType={EButtonType.Outline}
                    onClick={() => onUnblock(props.rowData)}
                >
                    Unblock
                </Button>
            );
        },
    },
    {
        title: 'Control',
        render: (props) => <ControlButtonsComponent {...props} />,
    },
];

export default adminListColumns;
